<div class="p-6 space-y-6">

  <!-- Header -->
  <div class="flex items-center justify-between">
    <div>
      <button (click)="goBack()" class="text-sm text-blue-600 hover:underline mb-2">
        ← Volver a auditoría de inscripciones
      </button>
      <h1 class="text-2xl font-bold text-gray-900">Bulk fix — Progreso</h1>
      <p class="mt-1 text-xs text-gray-500 font-mono">{{ batchId }}</p>
    </div>
    <button *ngIf="isRunning" (click)="cancel()" [disabled]="cancelling"
      class="px-4 py-2 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white text-sm font-medium rounded-lg transition-colors">
      {{ cancelling ? 'Cancelando...' : 'Cancelar batch' }}
    </button>
  </div>

  <!-- Summary card -->
  <div *ngIf="batch" class="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
      <div>
        <p class="text-xs uppercase text-gray-500 mb-1">Scope</p>
        <p class="text-sm font-semibold">{{ batch.scope === 'individual' ? 'Individuales' : 'Empresariales' }}</p>
      </div>
      <div>
        <p class="text-xs uppercase text-gray-500 mb-1">Acción</p>
        <p class="text-sm font-semibold">{{ describeAction() }}</p>
      </div>
      <div>
        <p class="text-xs uppercase text-gray-500 mb-1">Estado</p>
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border"
          [ngClass]="statusBadgeClass(batch.status)">
          {{ statusLabel(batch.status) }}
        </span>
      </div>
      <div>
        <p class="text-xs uppercase text-gray-500 mb-1">Iniciado</p>
        <p class="text-sm">{{ batch.startedAt | date:'dd/MM/yyyy HH:mm:ss' }}</p>
      </div>
    </div>

    <!-- Motivo -->
    <div class="mb-4">
      <p class="text-xs uppercase text-gray-500 mb-1">Motivo</p>
      <p class="text-sm text-gray-700 italic">{{ batch.comment }}</p>
    </div>

    <!-- Progress bar -->
    <div class="mb-4">
      <div class="flex justify-between text-xs text-gray-600 mb-1">
        <span>{{ batch.successCount + batch.failedCount + batch.skippedCount }} / {{ batch.totalItems }}</span>
        <span>{{ progress }}%</span>
      </div>
      <div class="h-3 bg-gray-200 rounded-full overflow-hidden">
        <div class="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-300"
          [style.width.%]="progress"></div>
      </div>
    </div>

    <!-- Counters -->
    <div class="grid grid-cols-4 gap-3">
      <div class="bg-gray-50 rounded-lg p-3 text-center">
        <p class="text-2xl font-bold text-gray-900">{{ batch.totalItems }}</p>
        <p class="text-xs text-gray-500 uppercase">Total</p>
      </div>
      <div class="bg-green-50 rounded-lg p-3 text-center">
        <p class="text-2xl font-bold text-green-700">{{ batch.successCount }}</p>
        <p class="text-xs text-green-700 uppercase">Éxito</p>
      </div>
      <div class="bg-red-50 rounded-lg p-3 text-center">
        <p class="text-2xl font-bold text-red-700">{{ batch.failedCount }}</p>
        <p class="text-xs text-red-700 uppercase">Fallidos</p>
      </div>
      <div class="bg-gray-50 rounded-lg p-3 text-center">
        <p class="text-2xl font-bold text-gray-700">{{ batch.skippedCount }}</p>
        <p class="text-xs text-gray-500 uppercase">Omitidos</p>
      </div>
    </div>
  </div>

  <!-- Items table -->
  <div *ngIf="batch" class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
    <div class="px-6 py-3 border-b border-gray-200 flex items-center justify-between">
      <h3 class="text-sm font-semibold text-gray-900">Detalle por inscripción</h3>
      <button (click)="refresh()" class="text-xs text-blue-600 hover:underline">Recargar</button>
    </div>
    <div class="overflow-x-auto max-h-[60vh]">
      <table class="min-w-full divide-y divide-gray-100 text-sm">
        <thead class="bg-gray-50 text-xs text-gray-600 uppercase tracking-wide sticky top-0">
          <tr>
            <th class="px-4 py-2 text-left">ID Inscripción</th>
            <th class="px-4 py-2 text-left">Valor anterior</th>
            <th class="px-4 py-2 text-left">Estado item</th>
            <th class="px-4 py-2 text-left">Iniciado</th>
            <th class="px-4 py-2 text-left">Finalizado</th>
            <th class="px-4 py-2 text-left">Duración</th>
            <th class="px-4 py-2 text-left">Filas</th>
            <th class="px-4 py-2 text-left">Error</th>
            <th class="px-4 py-2 text-center">Acción</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 bg-white">
          <tr *ngFor="let item of batch.items; trackBy: trackById" class="hover:bg-gray-50">
            <td class="px-4 py-2 font-mono text-gray-700">
              {{ item.targetEnrollmentId ?? item.targetCorporateEnrollmentId }}
            </td>
            <td class="px-4 py-2 text-gray-600 font-mono text-xs">
              <ng-container *ngIf="batch.action === 'SetAutoGenerate'">
                {{ item.previousValue === 'true' ? '✓ activo' : '— inactivo' }}
              </ng-container>
              <ng-container *ngIf="batch.action === 'SetStatus'">
                {{ enrollmentStatusLabel(item.previousValue ?? '') }}
              </ng-container>
            </td>
            <td class="px-4 py-2">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border"
                [ngClass]="statusBadgeClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
            </td>
            <td class="px-4 py-2 text-gray-500 text-xs">{{ item.startedAt ? (item.startedAt | date:'HH:mm:ss') : '—' }}</td>
            <td class="px-4 py-2 text-gray-500 text-xs">{{ item.finishedAt ? (item.finishedAt | date:'HH:mm:ss') : '—' }}</td>
            <td class="px-4 py-2 text-gray-500 text-xs">{{ item.durationMs != null ? item.durationMs + ' ms' : '—' }}</td>
            <td class="px-4 py-2 text-gray-500 text-xs">{{ item.affectedRows ?? '—' }}</td>
            <td class="px-4 py-2 text-red-600 text-xs max-w-xs truncate" [title]="item.error">{{ item.error || '—' }}</td>
            <td class="px-4 py-2 text-center">
              <button (click)="goToTarget(item)" type="button"
                class="text-blue-600 hover:text-blue-800" title="Abrir inscripción">
                <svg class="h-4 w-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!batch && loading" class="flex justify-center py-12">
    <svg class="animate-spin h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
    </svg>
  </div>

</div>
